import _ from 'lodash';

import { reactive, ref } from 'vue';

type MakeRequired<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>> &
  { [P in K]-?: Exclude<T[P], undefined> };

interface Mixin {
  data: Function;
}

export async function asyncForEach<T>(
  array: any[],
  callback: (item: T, index: number, array: T[]) => Promise<void>,
) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

export async function asyncForIn(
  obj: object,
  callback: (item: any, key: string, obj: object) => Promise<void>,
) {
  for (const key in obj) {
    await callback(obj[key], key, obj);
  }
}

// FindFirstChildByClass finds the first child element matching some class.
export function FindFirstChildByClass(element: any, className: string) {
  let foundElement = null;
  let found = false;
  function recurse(element, className) {
    for (let i = 0; i < element.childNodes.length && !found; i += 1) {
      const el = element.childNodes[i];
      const classes = el.className !== undefined ?
        el.className.split(' ') :
        [];
      for (let j = 0, jl = classes.length; j < jl; j += 1) {
        if (classes[j] === className) {
          found = true;
          foundElement = element.childNodes[i];
          break;
        }
      }
      if (found) break;
      recurse(element.childNodes[i], className);
    }
  }
  recurse(element, className);
  return foundElement;
}

export function MixinDataToReactiveData(mixin: Mixin) {
  if (!_.isFunction(mixin.data)) return {};
  const mixinData = mixin.data();
  const reactiveOutput = {};
  _.forEach(mixinData, (value, key) => {
    if (_.isPlainObject(value)) {
      reactiveOutput[key] = reactive(value);
    } else if (_.isArray(value)) {
      reactiveOutput[key] = reactive(value);
    } else {
      reactiveOutput[key] = ref(value);
    }
  });
  return reactiveOutput;
}

export function checkFields<T, K extends keyof T>(
  o: T | MakeRequired<T, K>, ...fields: K[]): o is MakeRequired<T, K> {
  return fields.every(f => !!o[f]);
}

export function uuid4(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
}
